import React from "react";
import Slider from "@mui/material/Slider";
import "../../../assets/css/slider.css"

class CustomSlider extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <Slider
          className="slider"
          color={this.props.color}
          sno={this.props.sno}
          min={this.props.min}
          value={this.props.value}
          defaultValue={this.props.default}
          onChange={this.props.handleChange}
          onChangeCommitted={this.props.handleChangeCommited}
          aria-label="Default"
          valueLabelDisplay="auto"
        />
      </div>
    );
  }
}

export default CustomSlider;
